export default __webpack_public_path__ + "static/media/ring-2@2x.224204e8.jpg";